import CheckboxField from 'components/formComponents/Base/CheckboxField';
import { CheckboxElementBlock } from '../../../../../types/global';
import { useFormContext } from 'react-hook-form';
import checkboxStyles from 'components/formComponents/Base/CheckboxField.module.scss';

type Props = {
  consentCheckboxes: CheckboxElementBlock[];
};

const RequiredConsentBlock = ({ consentCheckboxes }: Props) => {
  const {
    formState: { errors },
  } = useFormContext();
  const consentError =
    (errors?.consent?.root?.message as string | undefined) ??
    (errors?.consent?.message as string | undefined);

  return (
    <div data-cy="required-consent-block">
      {consentCheckboxes?.map((checkbox) => (
        <CheckboxField
          name={`consent.${checkbox.id}`}
          key={checkbox.id}
          label={checkbox.label}
        />
      ))}
      {consentError && (
        <span className={checkboxStyles.errorText} data-cy="base-error-text">
          {consentError}
        </span>
      )}
    </div>
  );
};

export default RequiredConsentBlock;
